// src/api/aiKeywordsApi.js *********************

import axios from 'axios';

const KEYWORDS_API_URL = '/api/keywords';

export const getKeywordsFromAI = async (text) => {
  try {
    console.log("Calling API with text:", text);

    const response = await axios.post(
      KEYWORDS_API_URL, 
      { text },
      {
        withCredentials: true, // ✅ Sends authentication cookies automatically
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    
    console.log("Raw Axios Response:", response);
    console.log("Extracted Data:", response.data);

    return response.data;
  } catch (error) {
    console.error("Error extracting keywords:", error.message);
    return { primary_keyword: null, pairs: [] };
  }
};